module.exports = __webpack_public_path__ + "img/action-Reemitere card.02420908.svg";